export default {
	VIEW: 'view',
	EDIT: 'edit',
	NEW: 'new',
};
